import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { PublicListingPriceHistoryFragment } from '@client/graphql/__generated__/types';
import dayjs from 'dayjs';
import { isNil } from 'lodash';
import { DEFAULT_DATE_FORMAT, formatPrice } from '~/common/utils/formatter';

type Props = {
  priceHistories: PublicListingPriceHistoryFragment[];
};

export const ListingPriceHistoryTable = ({ priceHistories }: Props) => {
  return (
    <TableContainer
      borderColor="whiteAlpha.200"
      borderLeft={0}
      borderRight={0}
      borderTop={0}
      borderWidth="1px"
      mt={4}
    >
      <Table variant="simple">
        <Thead>
          <Tr>
            {['Updated At', 'MLS Status', 'Price'].map((header, index) => (
              <Th
                key={index}
                fontSize="xs"
                fontWeight="medium"
                ps={0}
                width="calc(100% / 3)"
              >
                {header}
              </Th>
            ))}
          </Tr>
        </Thead>
        <Tbody>
          {priceHistories.map(
            ({ modified, mlsStatus, listPrice, closePrice }, index) => {
              const price = closePrice || listPrice;

              const tdProps = {
                fontWeight: 'medium',
                ps: 0,
                width: 'calc(100% / 3)',
              };

              return (
                <Tr key={index} fontWeight="medium" ps={0}>
                  <Td {...tdProps}>
                    {modified
                      ? dayjs(modified).format(DEFAULT_DATE_FORMAT)
                      : '-'}
                  </Td>
                  <Td {...tdProps}>{mlsStatus || '-'}</Td>
                  <Td {...tdProps}>
                    {!isNil(price) ? formatPrice(price) : '-'}
                  </Td>
                </Tr>
              );
            }
          )}
        </Tbody>
      </Table>
    </TableContainer>
  );
};
